import { Modal } from '@mantine/core';
import Prompt from '../AIPrompt/Prompt';
import CreatorCard from '../CreatorCard/CreatorCard';
import ModelActions from '../ModelActions/ModelActions';
import { IModel } from '../ModelCard/ModelCard';
import ModelViewer from '../ModelViewer/ModelViewer';
import styles from './ModelPreview.module.css';
import { Creator, Details, Meta, Model, Similar, Wrapper } from './ModelPreview.style';

export type ModelPreviewProps = {
  model: IModel;
  onClose: () => void;
};

export function ModelPreview(props: ModelPreviewProps) {
  const { model } = props;

  if (!model) return <></>;

  const { title, aiPrompt } = model ?? {};

  return (
    <Modal
      transitionProps={{ transition: 'fade', duration: 200 }}
      opened={true}
      onClose={props.onClose}
      size='xl'
      centered
      className={styles.modal}
      title={title}
    >
      <Wrapper className='ModelPreview-wrapper' data-testid='ModelPreview-wrapper'>
        <Model>
          <ModelViewer glb={''} />
        </Model>
        <Details>
          <ModelActions model={model} />
        </Details>
        <Meta>
          <Creator>
            <CreatorCard model={model} />
          </Creator>
          <Similar>
            <Prompt prompt={aiPrompt} />
          </Similar>
        </Meta>
      </Wrapper>
    </Modal>
  );
}

export default ModelPreview;
